export const singleLineText = new RegExp(/^[^\s][\s\S]{0,127}$/);
export const multiLineText = new RegExp(/^[^\s][\s\S]{0,511}$/);
export const singleLinePassword = new RegExp(/^([A-Za-z0-9.\@\%\+\\\/\'\!\#\$\^\?\:\,\(\)\{\}\[\]\~\-\_\.\&\*])*$/);
export const urlValidation = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/)
export const durationValidation = new RegExp(/^([0-9]{0,3})$/);
export const mongoNameValidation = new RegExp(/^[^\s][A-Za-z]{0,50}$/);
export const versionNameValidation = new RegExp(/^\d+([.-]\d+)*$/);
export default {
    singleLineText,
    multiLineText,
    singleLinePassword,
    urlValidation,
    durationValidation,
    mongoNameValidation,
};
